/**
 * This file is auto-generated from ChatBloodPressureInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const submitButton: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Continue';
        case 'pl':
            return 'Kontynuuj';
    }
};

export const systolicPlaceholder: Translation = lang => {
    switch (lang) {
        case 'en':
            return '120';
        case 'pl':
            return '120';
    }
};

export const diastolicPlaceholder: Translation = lang => {
    switch (lang) {
        case 'en':
            return '80';
        case 'pl':
            return '80';
    }
};

export const enterSystolic: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Please enter systolic pressure';
        case 'pl':
            return 'Proszę podać ciśnienie skurczowe';
    }
};

export const enterDiastolic: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Please enter diastolic pressure';
        case 'pl':
            return 'Proszę podać ciśnienie rozkurczowe';
    }
};

export const systolicRange: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Systolic pressure should be between 50 and 300';
        case 'pl':
            return 'Ciśnienie skurczowe powinno być między 50 a 300';
    }
};

export const diastolicRange: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Diastolic pressure should be between 30 and 200';
        case 'pl':
            return 'Ciśnienie rozkurczowe powinno być między 30 a 200';
    }
};

export const systolicMustBeHigher: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Systolic pressure must be higher than diastolic';
        case 'pl':
            return 'Ciśnienie skurczowe musi być wyższe niż rozkurczowe';
    }
};
